module.exports = __webpack_public_path__ + "img/h2.9b12e7b4.jpg";